import {HawkRequest} from '../_data/reports/ifs/ifs-request';
import {nullIfBlank} from './lang';

//TODO: gather various utils-style functions for working with reports to this file.

export function newHawk(addrFormValue: any): HawkRequest {
  return {
    city:     nullIfBlank(addrFormValue.city),
    phone:    nullIfBlank(addrFormValue.phone),
    postal:   nullIfBlank(addrFormValue.postalCode),
    province: nullIfBlank(addrFormValue.province),
    street:   nullIfBlank(addrFormValue.street),
    type:     nullIfBlank(addrFormValue.type)
  };
}
